<div class="container-fluid login-container">
  <div class="row">
    <!-- Left Side Image -->
    <div class="col-md-8 p-4">
      <img src="assets/img/login.jpg" alt="Login Image" class="img-fluid" style="height: 90vh;">
    </div>

    <!-- Right Side Login Form -->
    <div class="col-md-3">
      <div class="login-form">
        <h2 class="mb-4">Login</h2>
        <form class="mt-5">
          <p>Sign in with your Micro Merchant Systems account to access the Configuration Portal.</p>
          <div *ngIf="unauthorized" class="alert alert-danger mt-5" role="alert">
            You don't have access to this application. Please contact your administrator.
          </div>
          <div *ngIf="accessCheckFailed" class="alert alert-warning mt-5" role="alert">
            We could not verify your access right now. Please try again.
          </div>
          <ng-container *ngIf="unauthorized || accessCheckFailed; else signIn">
            <button type="button" (click)="login()" class="btn btn-primary w-100">Try Again</button>
            <button type="button" (click)="logout()" class="btn btn-outline-secondary w-100 mt-2">Sign Out</button>
          </ng-container>
          <ng-template #signIn>
            <button type="button" (click)="login()" class="btn btn-outline-primary w-100 mt-5">
              <i class="bi bi-microsoft"></i> Sign in with Microsoft
            </button>
          </ng-template>
        </form>
      </div>
    </div>
  </div>
</div>
